import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#b2d234"} }, "R", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#b2d234"} }, "C", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, " Référentiels ", -1)
const _hoisted_4 = {
  key: 1,
  class: "content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_ctx.isAuthenticated)
    ? (_openBlock(), _createBlock(_component_a_layout, {
        key: 0,
        class: "layout"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { type: "flex" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { class: "app-title" }, {
                    default: _withCtx(() => [
                      _hoisted_1,
                      _createTextVNode("éal' "),
                      _hoisted_2,
                      _createTextVNode("oncept ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_menu, {
                        theme: "dark",
                        mode: "horizontal",
                        style: { lineHeight: '64px' },
                        multiple: false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_menu_item, { key: "clients" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_router_link, { to: "/" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Clients")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_menu_item, { key: "referentiels" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_sub_menu, { key: "submenu-referentiels" }, {
                                title: _withCtx(() => [
                                  _hoisted_3
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_a_menu_item, { key: "submenu-referentiels-categories" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_router_link, { to: "/referentiel-categories" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Catégories")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_menu_item, { key: "submenu-referentiels-estimatif" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_router_link, { to: "/referentiel-estimatif" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Estimatif de référence")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_menu_item, { key: "deconnexion" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, { onClick: _ctx.logout }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Se déconnecter ")
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_layout_content, null, {
            default: _withCtx(() => [
              (!_ctx.referencesDataIsLoaded)
                ? (_openBlock(), _createBlock(_component_a_row, {
                    key: 0,
                    type: "flex"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        span: 24,
                        align: "center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_spin, { size: "large" })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_router_view)
                  ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}